/**
 * DMU-logoet som genbrugelig SVG.
 * Halvmånens cirkel spænder x 176–472, y 28–324 → kvadratisk viewBox.
 */

const STAR = '0,-21 4.9,-6.5 20,-6.5 7.9,2.5 12.4,17 0,8 -12.4,17 -7.9,2.5 -20,-6.5 -4.9,-6.5';
const STAR_POSITIONS = [
  [340, 108], [274, 134], [414, 137],
  [280, 206], [416, 203], [345, 232]
];

let uid = 0;

/**
 * @param {object}  opts
 * @param {number}  opts.size   Pixelstørrelse (kvadratisk)
 * @param {string}  opts.color  Fyldfarve
 */
export function logoMark({ size = 36, color = '#ef1c21' } = {}) {
  const id = `dmu-crescent-${uid++}`;
  const stars = STAR_POSITIONS
    .map(([x, y]) => `<polygon transform="translate(${x},${y})" points="${STAR}"/>`)
    .join('');

  return `
<svg width="${size}" height="${size}" viewBox="166 18 316 316" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
  <defs>
    <mask id="${id}">
      <rect x="166" y="18" width="316" height="316" fill="black"/>
      <circle cx="324" cy="176" r="148" fill="white"/>
      <circle cx="366" cy="150" r="140" fill="black"/>
    </mask>
  </defs>
  <rect x="166" y="18" width="316" height="316" fill="${color}" mask="url(#${id})"/>
  <g fill="${color}">${stars}</g>
</svg>`.trim();
}

/** Indsætter logoet i alle elementer med [data-logo] */
export function mountLogos(root = document) {
  root.querySelectorAll('[data-logo]').forEach(el => {
    el.innerHTML = logoMark({
      size:  Number(el.dataset.logoSize) || 36,
      color: el.dataset.logoColor || '#ef1c21'
    });
  });
}
